<template>
    <!-- modal-xl -->
    <b-modal id="editTeamMemberModal" title="Edit Team Member" title-class="font-18" hide-footer>
        <b-overlay :show="show">
            <div class="textcenter">
                <!-- <h5 class="mb-3">{{ this.searchForm.company_name }}</h5> -->
                <b-form>
                    <b-form-group label="Name:" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                        <b-form-input
                            v-model="$v.editUserForm.first_name.$model"
                            size="sm"
                            :state="validateState('first_name')"
                            aria-describedby="input-1-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                            Required
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group label="Surname:" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                        <b-form-input
                            v-model="$v.editUserForm.last_name.$model"
                            size="sm"
                            :state="validateState('last_name')"
                            aria-describedby="input-1-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                            Required
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Email:" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                        <b-form-input
                            v-model="$v.editUserForm.email.$model"
                            size="sm"
                            type="email"
                            :state="validateState('email')"
                            aria-describedby="input-2-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                            Required
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <div class="align-text-setting-r mr-5 ml-4">
                        <b-form-checkbox
                            :disabled="checkPasswordEntered()"
                            size="sm"
                            id="checkbox-1"
                            @change="toggleEnableInput"
                            name="checkbox-1"
                            class="mt-4 mb-2 ml-5"
                            switch
                        >
                            Change password
                        </b-form-checkbox>
                    </div>

                    <b-form-group
                        v-if="!disabledPassword"
                        id="example-input-group-1"
                        label="Password:"
                        label-cols-sm="3"
                        class="align-text-setting mr-5"
                        label-size="sm"
                    >
                        <!-- <b-form-input :disabled="disabledPassword" type="password" id="example-input-1" name="example-input-1"></b-form-input> -->
                        <b-form-input
                            size="sm"
                            type="password"
                            v-model="$v.editUserForm.password.$model"
                            :state="validateState('password')"
                        ></b-form-input>

                        <b-form-invalid-feedback id="input-1-live-feedback " class="text-left ml-2">
                            Please enter a valid password, also needs to be atleast 8 characters long</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-form>
            </div>

            <div class="modal-footer d-flex justify-content-end">
                <b-button variant="primary" type="button" class="btn btn-primary" @click="editUser">
                    Update User
                </b-button>
                <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal">
                    Cancel
                </b-button>
            </div>
        </b-overlay>
    </b-modal>
</template>

<script>
//eslint-disable-next-line
import Swal from "sweetalert2";
import { adminComputed, adminMethods, userAdministrationComputed, userAdministrationMethods } from "../../../state/helpers";
//eslint-disable-next-line
import { required, minLength, maxLength, numeric, date, email } from "vuelidate/lib/validators";

export default {
    data: () => ({
        show: false,
        disabledPassword: true,
        formSubmit: false,
        //values for the calendar
        editUserForm: {
            user_id: "",
            first_name: "",
            last_name: "",
            email: "",
            password: "",
        },
    }),
    validations: {
        editUserForm: {
            first_name: {
                required,
            },
            last_name: {
                required,
            },
            email: {
                required,
                email,
            },
            password: {
                minLength: minLength(8),
            },
        },
    },
    computed: {
        ...adminComputed,
        ...userAdministrationComputed,
    },
    methods: {
        ...adminMethods,
        ...userAdministrationMethods,
        checkPasswordEntered() {
            if (this.editUserForm.password.length > 0) {
                return true;
            }
            //eslint-disable-next-line
            console.log("the length", this.editUser.password);
            return false;
        },
        toggleEnableInput() {
            this.$nextTick(() => {
                this.disabledPassword = !this.disabledPassword;
            });
        },
        validateState(name) {
            if (this.formSubmit) {
                const { $dirty, $error } = this.$v.editUserForm[name];
                return $dirty ? !$error : null;
            }
        },

        closeModal() {
            this.$bvModal.hide("editTeamMemberModal");
        },

        editUser() {
            //eslint-disable-next-line
            console.log(this.editUserForm);
            this.formSubmit = true;

            this.$v.editUserForm.$touch();
            if (this.$v.editUserForm.$anyError) {
                return;
            }
            this.show = true;

            //eslint-disable-next-line
            console.log("thsis show", this.show);

            //remove password from
            if (this.editUserForm.password == null || this.editUserForm.password.length < 7) {
                delete this.editUserForm["password"];
            }
            //eslint-disable-next-line
            console.log("passed validation");

            Swal.fire({
                title: ` Update Team Member `,
                text: `Update ${this.selected_user.first_name}'s deatils?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Confirm",
            }).then((result) => {
                if (result.value) {
                    this.saveEditTeamMember(this.editUserForm).then(() => {
                        Swal.fire(`Team Member Updated`, "", "success");

                        //refresh
                        // this.setSupplierCertificates(this.selected_supplier_details.id);
                        this.setUsersForPermissions();

                        this.closeModal();

                        this.show = false;
                    });
                } else {
                    this.show = false;
                }
            });

            //swal
        },
    },
    mounted() {
        this.editUserForm.user_id = this.selected_user.id;
        this.editUserForm.first_name = this.selected_user.first_name;
        this.editUserForm.last_name = this.selected_user.last_name;
        this.editUserForm.email = this.selected_user.email;
        //eslint-disable-next-line
        console.log("add team member mdoal", this.selected_user);
    },
};
</script>

<style lang="scss" scoped>
.align-text-setting {
    text-align: right;
}
@media only screen and (max-width: 990px) {
    .align-text-setting {
        text-align: left;
    }
    .align-text-setting-r {
        text-align: right;
    }
}
</style>
